import { render, staticRenderFns } from "./efficientDialog.vue?vue&type=template&id=a589c3ce&scoped=true"
import script from "./efficientDialog.vue?vue&type=script&lang=js"
export * from "./efficientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a589c3ce",
  null
  
)

export default component.exports